import * as i18n from 'i18next';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Col } from 'reactstrap';

import { navigateToHomeScreen } from '../actions';
import { RELATIVE_PAGE_PATHS } from '../utils/constants';
import navigationUtils from '../utils/navigationUtils';
import InternalServerErrorScreen from './errors/InternalServerErrorScreen';
import NotFoundErrorScreen from './errors/NotFoundErrorScreen';
import UnhandledErrorScreen from './errors/UnhandledErrorScreen';
import JournalReadOnlyScreen from './journal/JournalReadOnlyScreen';
import AnalyticsReadOnlyPage from './analytics/AnalyticsReadOnlyPage';
import PhotoPreviewScreen from './journal/PhotoPreviewScreen';
import StickerReadOnlyScreen from './journal/StickerReadOnlyScreen';
import NavigationComponent from './NavigationComponent';
import ActivateProfile from './profile/ActivateProfileScreen';
import Login from './profile/LoginScreen';
import RequestPasswordReset from './profile/RequestPasswordResetScreen';
import ResetPassword from './profile/ResetPasswordScreen';
import RegisterScreen from './register/RegisterScreen';
import WelcomeScreen from './WelcomeScreen';
import TermsAndConditions from './LegalPolicies/TermsAndConditions';
import Gdpr from './LegalPolicies/Gdpr';
import ContactPolicies from './LegalPolicies/ContactPolicies';

class Unauthenticated extends Component {
  render() {
    let screenHeader = i18n.t('welcomeScreen:headerText.welcomeMsg');
    const classes = [
      'flexColumnCentered',
      'fix-padding-safari',
      'pr-0',
      'pl-0',
    ];

    if (!navigationUtils.isCurrentPage(RELATIVE_PAGE_PATHS.HOME)) {
      classes.push('top-banner-container');
    }
    return (
      <Fragment>
        {!navigationUtils.isCurrentPage(RELATIVE_PAGE_PATHS.HOME) ? (
          <Col md={4} className="noPadding">
            <NavigationComponent
              header={screenHeader}
              previousPage={this.props.navigateToHomeScreen}
            />
          </Col>
        ) : null}
        <div>
          <NavigationComponent />
          <div className="ml-3 mr-3">
            <div className="main-section">
              <Col xs={12} className={classes.join(' ')}></Col>
              <Switch>
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.HOME}
                  component={WelcomeScreen}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.REGISTER}
                  component={RegisterScreen}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.ACTIVATE_PROFILE}
                  component={ActivateProfile}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.REQUEST_PASSWORD_RESET}
                  component={RequestPasswordReset}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.RESET_PASSWORD}
                  component={ResetPassword}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.LOGIN}
                  component={Login}
                />
                <Route
                  path={RELATIVE_PAGE_PATHS.TERMS_AND_CONDITIONS}
                  component={TermsAndConditions}
                />
                <Route path={RELATIVE_PAGE_PATHS.GDPR} component={Gdpr} />
                <Route
                  path={RELATIVE_PAGE_PATHS.CONTACTS_POLICIES}
                  component={ContactPolicies}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.JOURNAL_READ_ONLY}
                  component={JournalReadOnlyScreen}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.ANALYTICS_READ_ONLY}
                  component={AnalyticsReadOnlyPage}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.STICKER_READ_ONLY + ':id'}
                  component={StickerReadOnlyScreen}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.PHOTO_PREVIEW + ':photo'}
                  component={PhotoPreviewScreen}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.INTERNAL_SERVER_ERROR}
                  render={() => (
                    <InternalServerErrorScreen isUnauthenticated={true} />
                  )}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.NOT_FOUND}
                  render={() => (
                    <NotFoundErrorScreen isUnauthenticated={true} />
                  )}
                />
                <Route
                  exact
                  path={RELATIVE_PAGE_PATHS.UNHANDLED_ERROR}
                  render={() => (
                    <UnhandledErrorScreen isUnauthenticated={true} />
                  )}
                />
                <Route
                  render={() => (
                    <NotFoundErrorScreen isUnauthenticated={true} />
                  )}
                />
              </Switch>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(null, { navigateToHomeScreen })(Unauthenticated);
